import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Handover, HandoverState } from '@handover/shared-types';

// Initial state
const initialState: HandoverState = {
  handoverDocData: [],
  taskDocData: null,
  accessDocData: null,
  isCreatedBy: null,
  isAccessLevelRole: null,
  isPermittedUser: null,
  isBlockedUser: null,
  email: '',
  message: '',
  deleteStatus: 'idle',
  deleteError: null,
};

const handoverSlice = createSlice({
  name: 'handover',
  initialState,
  reducers: {
    setHandoverDocState: (state, action: PayloadAction<Handover | Handover[]>) => {
      state.handoverDocData = action.payload;
    },
    setElementDocState: (state, action: PayloadAction<object>) => {
      state.taskDocData = action.payload;
    },
    setAccessDocState: (state, action: PayloadAction<object>) => {
      state.accessDocData = action.payload;
    },
    setUserRolePermissions: (
      state,
      action: PayloadAction<{
        isCreatedBy: boolean;
        isAccessLevelRole: boolean;
        isPermittedUser: boolean;
        isBlockedUser: boolean;
      }>
    ) => {
      const { isCreatedBy, isAccessLevelRole, isPermittedUser, isBlockedUser } = action.payload;
      state.isCreatedBy = isCreatedBy;
      state.isAccessLevelRole = isAccessLevelRole;
      state.isPermittedUser = isPermittedUser;
      state.isBlockedUser = isBlockedUser;
    },
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    setMessage: (state, action: PayloadAction<string>) => {
      state.message = action.payload;
    },
    resetHandoverState: state => {
      state.handoverDocData = null;
      state.taskDocData = null;
      state.accessDocData = null;
      state.isCreatedBy = null;
      state.isAccessLevelRole = null;
      state.isPermittedUser = null;
      state.isBlockedUser = null;
      state.email = '';
      state.message = '';
    },
    deleteHandoverStart: state => {
      state.deleteStatus = 'loading';
      state.deleteError = null;
    },
    deleteHandoverSuccess: state => {
      state.deleteStatus = 'succeeded';
    },
    deleteHandoverFailure: (state, action: PayloadAction<string>) => {
      state.deleteStatus = 'failed';
      state.deleteError = action.payload;
    },
  },
});

export const {
  setHandoverDocState,
  setElementDocState,
  setAccessDocState,
  setUserRolePermissions,
  setEmail,
  setMessage,
  resetHandoverState,
  deleteHandoverStart,
  deleteHandoverSuccess,
  deleteHandoverFailure,
} = handoverSlice.actions;

export default handoverSlice.reducer;
